import axios from "axios";
import { useGlobal } from "../../GlobalContext";

const signageUrl = process.env.REACT_APP_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
 

export function getHeader(token) {
return {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: token,
};
}
export const getAvgPerDayApi = async (token) => {
    
    try {
        const response = await axios.get(signageUrl + `gatedashboard/average_perday`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getCountApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `gatedashboard/count`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getTodayAttenApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `gatedashboard/today`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getMonthAttenApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `gatedashboard/monthly`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getIncommerApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `gatedashboard/incomers`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
